<template>
  <div class="add-card">
    <div class="add-card-main">
      <div class="add-product">
        <div class="add-pro-left">
          <a :href="product.path">
            <v-img-card
              :data_src="
                variants.feature_image
                  ? variants.feature_image.thumbnail
                  : product.feature_image
                  ? product.feature_image.thumbnail
                  : defaultImage
              "
              :data_url="variants.feature_image
                  ? variants.feature_image.url
                  : product.feature_image
                  ? product.feature_image.url
                  : defaultImage"
              :card_type="card_type"
              :use_product_card_config="true"
            ></v-img-card>
            <span
              class="sale_tag saveprice_tag secondary_title"
              v-if="
                show_tag &&
                variants.price - 0 <
                  variants.regular_price - 0
              "
              >-{{
                100 -
                Math.round(
                  ((variants.price - 0) /
                    (variants.regular_price - 0)) *
                    100
                )
              }}%</span>
          </a>
        </div>
        <div class="add-pro-center">
          <div
            class="add-pro-title page_text_font"
            v-if="show_name"
            :class="show_one_line ? 'oneline' : ''"
          >
            <a :href="product.path" class="">
              {{ product.post_title }}
            </a>
          </div>
          <v-selectprice
            :price="variants.price"
            :font-size="14"
            :regular_price_num="
              variants.price - 0 < variants.regular_price - 0
                ? variants.regular_price
                : 0
            "
            :disable_select="true"
            :regular-font-size="14"
            :country="$store.state.pricetype"
          ></v-selectprice>
          <div
            class="add-pro-select"
            v-if="product.variants && product.variants.length > 1"
          >
            <v-allOptionSelect
              v-if="show_add_btn"
              :options="product.variants"
              :addproduct="addproduct"
              :index="index"
              :selectvariants="selectvariants"
            ></v-allOptionSelect>
          </div>
          <div style="display:none" class="add-btn" v-if="show_add_btn">
          <button
            class="add-button"
            v-if="variants.buy_able"
            @click="addcart(index)"
          >
            <span class="secondary_title"> ADD + </span>
          </button>
          <button v-else class="add-button" id="slodout">
            <span class="secondary_title">{{ $t("detail.sold_out") }}</span>
          </button>
        </div>
        </div>
      </div>
      <!-- 底部Add按钮 -->
      <div class="add-bottom">
        <div class="add-bottom__comments-star" v-if="comment&&product.review_status&&product.review_status=='open'">
          <v-comments-star
            :disabled="true"
            :average_rating="product.average_rating"
            font_size="18"
          ></v-comments-star>
          <span>
            ({{ product.review_count }})
          </span>
        </div>

        <div class="add-bottom__btn-wrapper" v-if="show_add_btn">
          <span v-if="adding">
            <i class="add-bottom__btn add-bottom__btn--loading loading" />
          </span>
          <template v-else>
            <a
              class="add-bottom__btn add-bottom__btn--add"
              v-if="variants.buy_able"
              @click="() => handleAddcart(index)"
            >
              ADD+
            </a>
            <a v-else class="add-bottom__btn add-bottom__btn--slodout">
              <span class="secondary_title">{{ $t("detail.sold_out") }}</span>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vAllOptionSelect from "./allOptionSelect.vue";
import vCommentsStar from "../view/comments/commentsstar";
import vImgCard from "./imgCard.vue";

export default {
  props: {
    comment:{
      require:true,
    },
    product: {
      require: true,
    },
    variants: {
      require: true,
    },
    recommended_product: {},
    addproduct: {},
    index: {},
    selectvariants: {},
    addcart: {
      type: Function,
      default: null
    },
    show_name: {},
    show_one_line: {},
    show_tag: {},
    show_add_btn: {},
    card_type: {},
  },
  data() {
    return {
      adding: false
    };
  },
  methods: {
    // 添加到购物车
    async handleAddcart(index) {
      this.adding = true;
      if (this.addcart) {
        await this.addcart(index, 'addCard')
      }

      this.adding = false
    }
  },
  components: {
    vAllOptionSelect,
    vCommentsStar,
    vImgCard,
  },
};
</script>
<style scoped lang='scss'>
.add-card {
  line-height: 1;
  background-color: #f7f7f9;
  padding: 10px;
  .add-card-main {
    .add-product {
      display: flex;
      .add-pro-left {
        width: 35%;
        a{
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          .sale_tag{
            position: absolute;
            padding: 6px 12px;
            color: #fff;
            font-size: 12px;
            line-height: 14px;
            text-align: center;
            z-index: 9999;
            background: #333;
          }
        }
      }
      .add-pro-center {
        flex: 1;
        padding: 0 0 0 10px;
        overflow: hidden;
        text-align: left;
        .add-pro-title {
          font-size: 14px;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          a {
            text-decoration: none;
            color: #222222;
          }
        }
        .selectpricewrap {
          margin-top: 10px;
        }
        .add-pro-select {
          width: 100%;
          margin-top: 15px;
        }
      }
    }
    // 底部添加按钮
    .add-bottom {
      margin-top: 15px;
      padding-top: 10px;
      border-top: 1px solid #dedede;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &__comments-star {
        display: flex;
        align-items: center;
        &>span {
          margin-left: 6px;
          font-size: 14px;
        }
      }
      &__btn-wrapper {
        flex: 1;
        text-align: right;
      }
      &__btn {
        color: #000;
        &--loading {
          width: 18px;
          height: 18px;
          border-width: 2px;
          border-color: #555;
          margin-right: 5px;
        }
        &--add {
          display: inline-block;
          line-height: 1;
          cursor: pointer;
          transition: all 0.1s;
          font-weight: 500;
          font-family: LatoRegular;
          font-size: 14px;
          text-decoration: underline;
        }
        &--slodout {
          cursor: default;
          text-decoration: none;
        }
      }
    }
  }

  .loading {
    box-sizing: border-box;
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    border-color: #fff;
    border-width: 2px;
    border-style: solid;
    border-top-color: transparent !important;
    animation: spin 1s infinite linear;
  }
}
@media screen and(max-width:768px) {
  .add-card {
    .add-card-main {
      .add-product {
        display: flex;
        .add-pro-left {
          width: 40%;
        }
      }
    }
  }
}
</style>
